module.exports = __webpack_public_path__ + "img/2.fdf35174.png";